var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',[_c('i',{staticClass:"fa fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }